import { useState, useEffect } from 'react'

interface BravicLogoAnimatedProps {
  className?: string
}

const WORD = 'BRAVIC'
const TYPE_SPEED = 250
const DELETE_SPEED = 120
const BLINK_SPEED = 530
const PAUSE_DELAY = 5000

type Phase = 'typing' | 'paused' | 'deleting'

export default function BravicLogoAnimated({ className = '' }: BravicLogoAnimatedProps) {
  const [charCount, setCharCount] = useState(0)
  const [phase, setPhase] = useState<Phase>('typing')
  const [showSlash, setShowSlash] = useState(true)

  useEffect(() => {
    if (phase === 'typing') {
      if (charCount < WORD.length) {
        const timeout = setTimeout(() => setCharCount((c) => c + 1), TYPE_SPEED)
        return () => clearTimeout(timeout)
      }
      const timeout = setTimeout(() => setPhase('deleting'), PAUSE_DELAY)
      return () => clearTimeout(timeout)
    }

    if (phase === 'deleting') {
      if (charCount > 1) {
        const timeout = setTimeout(() => setCharCount((c) => c - 1), DELETE_SPEED)
        return () => clearTimeout(timeout)
      }
      const timeout = setTimeout(() => setPhase('typing'), PAUSE_DELAY)
      return () => clearTimeout(timeout)
    }
  }, [charCount, phase])

  useEffect(() => {
    const interval = setInterval(() => setShowSlash((v) => !v), BLINK_SPEED)
    return () => clearInterval(interval)
  }, [])

  return (
    <span
      className={`inline-flex items-baseline font-extrabold uppercase select-none ${className}`}
    >
      {/* Hidden full text to reserve fixed width */}
      <span className="relative">
        <span className="invisible" aria-hidden="true">
          <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{WORD}</span>
          <span style={{ fontFamily: "'Barlow Semi Condensed', sans-serif", fontSize: '1.8rem' }}>
            /
          </span>
        </span>
        <span className="absolute left-0 top-0 inline-flex items-baseline">
          <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", color: '#e6e6e6' }}>
            {WORD.slice(0, charCount)}
          </span>
          <span
            style={{
              fontFamily: "'Barlow Semi Condensed', sans-serif",
              color: '#00A693',
              opacity: showSlash ? 1 : 0,
              fontSize: '1.8rem',
            }}
            className="transition-opacity duration-100"
          >
            /
          </span>
        </span>
      </span>
    </span>
  )
}
